@if(!isLoading){ 
  <div class="device-item">
    <h3>Nummer: {{device.number}}</h3>
    <h2>{{device.description}}</h2>
    <h3>Artikel: {{device?.articleName || '-'}}</h3>
    <h3>Kunde: {{device?.addressName || '-'}}</h3>
  </div>
}
@else {
  <section id="loading">
    <svg class="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="var(--text)" d="M256 32C256 14.33 270.3 0 288 0C429.4 0 544 114.6 544 256C544 302.6 531.5 346.4 509.7 384C500.9 399.3 481.3 404.6 465.1 395.7C450.7 386.9 445.5 367.3 454.3 351.1C470.6 323.8 480 291 480 255.1C480 149.1 394 63.1 288 63.1C270.3 63.1 256 49.67 256 31.1V32z"/></svg>
  </section>
}
